<div class="main-card shadow-sm">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex align-items-center gap-2">
      <fa-icon [icon]="faWallet" style="font-size: 14px; color: #00305C;"></fa-icon>
      <span class="main-heading fw-smbold">Payments Summary</span>
    </div>
    @if (!loader && !errMsg) {
      <button class="btn view-all-btn d-flex align-items-center gap-1" (click)="viewAllPayments(paymentsModal)">
        Full breakdown <fa-icon [icon]="faChevronRight" style="font-size: 10px;"></fa-icon>
      </button>
    }
  </div>

  <!-- Top Summary Cards -->
  <div class="row g-2 mb-3">
    <div class="col-6">
      <div class="top-card h-100">
        <div class="top-card-heading mb-1">Net Received</div>
        <div class="top-card-value-lite fw-bold">{{ receivedToday | number }}</div>
      </div>
    </div>
    <div class="col-6">
      <div class="top-card h-100 d-flex flex-column justify-content-between">
        <div>
          <div class="top-card-heading mb-1">Unsettled Balance</div>
          <div class="fw-bold" style="font-size: 14px;">{{ unsettledBalance | number }}</div>
        </div>
        <div class="mt-2 pt-2 border-top">
          <div class="top-card-heading mb-1">Credits Outstanding</div>
          <div class="fw-bold" style="font-size: 14px;">{{ creditsAmount | number }}</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Payment Categories List -->
  <div class="categories-wrapper">
    @for (category of paymentCategories; track category; let index = $index; let last = $last) {
      <div class="category-section">
        <!-- Category Header Row -->
        <div class="category-header" [class.mt-1]="index != 0">
          <div class="d-flex align-items-center gap-2">
            @if (category.title === 'Credits') {
              <div class="credits-icon-wrapper">
                <fa-icon [icon]="faCreditCard" class="cat-icon card-base"></fa-icon>
                <fa-icon [icon]="faClock" class="clock-overlay"></fa-icon>
              </div>
            } @else {
              <fa-icon [icon]="category.icon" class="cat-icon"></fa-icon>
            }
            <span class="category-title">{{ category.title }}</span>
          </div>
          <span class="category-total">{{ category.total < 0 ? '-' : '' }}₹{{ (category.total < 0 ? -category.total : category.total) | number }}</span>
        </div>
        <!-- Loader State for Details -->
        @if (loader) {
          <div class="text-center py-3 border-0">
            <app-loader [loadingIcon]="loader"></app-loader>
          </div>
        }
        <!-- Error State for Details -->
        @if (!loader && errMsg) {
          <div class="detail-row border-0 justify-content-center">
            <p class="text-danger mb-0 small fw-bold">{{ errMsg }}</p>
          </div>
        }
        <!-- Detail Rows -->
        @if (!loader && !errMsg) {
          @if (category.details && category.details.length > 0) {
            @for (item of category.details | slice:0:2; track item; let lastItem = $last) {
              <div class="detail-row"
                [class.no-border]="lastItem && last">
                @if (!last) {
                  <span class="detail-label">{{ item.label }}</span>
                }
                <span class="detail-location" [class.span-2]="last">{{ item.location }}</span>
                <span class="detail-amount" [ngClass]="(item.amount < 0 )? 'text-danger':'text-primary'">{{ item.amount < 0 ? '-' : '' }}₹{{ (item.amount < 0 ? -item.amount : item.amount) | number }}</span>
              </div>
            }
          } @else {
            <div class="detail-row border-0 justify-content-center">
              <span class="text-muted small fw-bold">No Transactions...</span>
            </div>
          }
        }
        @if (!last) {
          <div class="section-divider"></div>
        }
      </div>
    }
  </div>
</div>

<!-- Modal Template -->
<ng-template #paymentsModal let-modal>
  <div class="modal-header border-0 pb-0">
    <h5 class="fw-bold mb-0 main-heading">Full Breakdown</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <div class="modal-body p-2 p-md-4">
    <div class="categories-wrapper">
      @for (category of paymentCategories; track category; let index = $index; let last = $last) {
        <div class="category-section">
          <div class="category-header" [class.mt-1]="index != 0">
            <div class="d-flex align-items-center gap-2">
              @if (category.title === 'Credits') {
                <div class="credits-icon-wrapper">
                  <fa-icon [icon]="faCreditCard" class="cat-icon card-base"></fa-icon>
                  <fa-icon [icon]="faClock" class="clock-overlay"></fa-icon>
                </div>
              } @else {
                <fa-icon [icon]="category.icon" class="cat-icon"></fa-icon>
              }
              <span class="category-title">{{ category.title }}</span>
            </div>
            <span class="category-total">{{ category.total < 0 ? '-' : '' }}₹{{ (category.total < 0 ? -category.total : category.total) | number }}</span>
          </div>
          @if (category.details && category.details.length > 0) {
            @for (item of category.details; track item; let lastItem = $last) {
              <div class="detail-row"
                [class.no-border]="lastItem && last">
                @if (!last) {
                  <span class="detail-label">{{ item.label }}</span>
                }
                <span class="detail-location" [class.span-2]="last">{{ item.location }}</span>
                <span class="detail-amount" [ngClass]="(item.amount < 0 )? 'text-danger':'text-primary'">{{ item.amount < 0 ? '-' : '' }}₹{{ (item.amount < 0 ? -item.amount : item.amount) | number }}</span>
              </div>
            }
          } @else {
            <div class="detail-row border-0 justify-content-center">
              <span class="text-muted small fw-bold">No Transactions...</span>
            </div>
          }
          @if (!last) {
            <div class="section-divider"></div>
          }
        </div>
      }
    </div>
  </div>
</ng-template>
